import { divIcon } from 'leaflet'

const pinSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="20" height="30">
  <path d="M12 0C5.373 0 0 5.373 0 12c0 9.6 12 24 12 24S24 21.6 24 12C24 5.373 18.627 0 12 0z" fill="#1465b7" stroke="rgba(0,0,0,0.3)" stroke-width="1"/>
  <circle cx="12" cy="11" r="4" fill="white" opacity="0.85"/>
</svg>`

const MarkerIcon = divIcon({
  html: pinSvg,
  className: 'property-pin',
  iconSize: [20, 30],
  iconAnchor: [10, 30],
})

export { MarkerIcon }
